import React, {useEffect} from 'react';
import {Popover} from '@mantine/core';

import {Container, Button, OptionList, Option} from './styles';
import {Operators} from 'shared/migration-components/filter-list/types';

interface Props {
  value?: Operators;
  onChange: (value: Operators) => void;
  operatorType: 'string' | 'numeric' | 'date';
  opened: boolean;
  open: () => void;
  close: () => void;
  themeLess?: boolean;
}

enum NumericOperators {
  Exact = 'equals',
  NotEqual = 'notIn',
  GreaterThanEqual = 'gte',
  LessThanEqual = 'lte',
}

enum DateOperators {
  Exact = 'equals',
  GreaterThanEqual = 'gte',
  LessThanEqual = 'lte',
}

enum StringOperators {
  Equal = 'contains',
  NotEqual = 'notIn',
}

const operatorsTranslation: {[key in Operators]: string} = {
  contains: 'igual',
  equals: 'igual',
  notIn: 'diferente',
  gte: 'maior ou igual',
  lte: 'menor ou igual',
};

const Select: React.FC<Props> = ({
  onChange,
  value,
  opened,
  open,
  close,
  themeLess,
  operatorType,
}) => {
  const availableOperators =
    operatorType === 'string'
      ? StringOperators
      : operatorType === 'numeric'
      ? NumericOperators
      : DateOperators;

  useEffect(() => {
    if (!value) onChange(Object.values(availableOperators)[0] as any);
  }, [value]);

  return (
    <Popover
      {...{opened}}
      onClose={close}
      zIndex={1001}
      position="bottom"
      styles={{dropdown: {padding: 0}}}>
      <Popover.Target>
        <Button onClick={open} {...{active: opened, themeLess}}>
          {value && operatorsTranslation[value]}
        </Button>
      </Popover.Target>
      <Popover.Dropdown>
        <Container>
          <OptionList>
            {Object.values(availableOperators).map((operator, index) => (
              <Option
                className="ignore"
                {...{active: operator === value}}
                key={index}
                onClick={() => onChange(operator)}>
                {/* @ts-ignore */}
                {operatorsTranslation[operator]}
              </Option>
            ))}
          </OptionList>
        </Container>
      </Popover.Dropdown>
    </Popover>
  );
};

export default Select;
